import { subotoMockEhrGroupIds } from "@/configuration/groups/suboto/ehr";

export const mockEhrGroupIds: readonly string[] = [...subotoMockEhrGroupIds];
